import classNames from 'classnames';
import PillContact, {
  Props as PillContactProps
} from '../../Molecules/PillContact';
import Button, {
  Props as ButtonProps
} from '../../Atoms/Button';
import List from '../../Molecules/List';
import Text from '../../Atoms/Text';
import Image, {
  Props as ImageProps
} from '../../Atoms/Image';

interface Props {
  avatar: ImageProps;
  title: string;
  name: string;
  position: string;
  pills: PillContactProps[];
  buttons: ButtonProps[];
  list?: string[] | JSX.Element[];
  className?: string;
}
function CardPersonContact({
  avatar,
  name,
  pills,
  position,
  title,
  buttons,
  list,
  className
}: Props) {
  return (
    <div
      className={classNames([
        'flex flex-col gap-3.5 overflow-hidden rounded-xl border-[1.5px] border-sl-gray-light bg-white px-5 shadow-xl lg:px-7',
        className,
        !list && 'pb-5'
      ])}
    >
      <div className="flex flex-row items-center justify-between gap-3.5 py-7">
        <div className="flex flex-col gap-3.5">
          <Text
            size="base"
            color="blue"
            weight={600}
            font="circular"
          >
            <span>
              {title}
              <br />
              <b>{name}</b>
            </span>
          </Text>

          <Text font="circular" size="xs" color="blue">
            {position}
          </Text>
        </div>
        <div className="relative flex h-28 w-28 shrink-0 overflow-hidden rounded-full shadow-xl md:h-36 md:w-36">
          <Image {...avatar} cover />
        </div>
      </div>
      <div className="flex flex-col gap-3.5">
        {pills.map((pill) => (
          <PillContact
            key={pills.indexOf(pill)}
            {...pill}
          />
        ))}
      </div>

      {buttons && (
        <div className="mt-5 flex flex-col items-stretch gap-5">
          {buttons.map((button) => (
            <Button
              {...button}
              key={buttons.indexOf(button)}
            />
          ))}
        </div>
      )}

      {list && (
        <div className="-mx-5 rounded-xl bg-sl-blue py-7 px-3.5 lg:-mx-7 lg:p-7">
          <List
            font="circular"
            listItems={list}
            animateMobile
            color="white"
            icon="checkmark"
          />
        </div>
      )}
    </div>
  );
}

export default CardPersonContact;
